import { createSwiper, withResize } from '../../components/swiper-init.js';

export function initSwiperWebinarsWithResize() {
  withResize(() => createSwiper('is--webinar-inner'));
}
